import { render, staticRenderFns } from "./BoxContent4.vue?vue&type=template&id=21a9b37d&scoped=true"
import script from "./BoxContent4.vue?vue&type=script&lang=js"
export * from "./BoxContent4.vue?vue&type=script&lang=js"
import style0 from "./BoxContent4.vue?vue&type=style&index=0&id=21a9b37d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a9b37d",
  null
  
)

export default component.exports